/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ConfrontationInfoDto { 
    type?: ConfrontationInfoDto.TypeEnum;
    civilization1?: string;
    civilization2?: string;
    armiesCount1?: number;
    armiesCount2?: number;
}
export namespace ConfrontationInfoDto {
    export type TypeEnum = 'ARMIES_VS_ARMIES' | 'ARMIES_VS_CITY' | 'ARMIES_VS_VILLAGE' | 'ARMIES_VS_SCOUTS';
    export const TypeEnum = {
        ARMIES: 'ARMIES_VS_ARMIES' as TypeEnum,
        CITY: 'ARMIES_VS_CITY' as TypeEnum,
        VILLAGE: 'ARMIES_VS_VILLAGE' as TypeEnum,
        SCOUTS: 'ARMIES_VS_SCOUTS' as TypeEnum
    };
}